module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAsklEQVQ4T+3SPQrCMByG8edFwcXNK4iCdxD1CoKTXqOrt3By1gO4+4EeQxydu4kfyF9aKEQwkraOZgtJfiQPkZmdgQrlxlNmdgVq5RxuP4VWQAw8Ct4qydJQctjMIqBdEIolRRm0AQYOdAHuHrgK1J21o6SWDxpLWn6CzKwL7EOhiaSFB+oBu1BoCqw9T+sA81AoT/evjf5QWuCt0Rbo5wnj7D1JamYfcgYMgXSecxwkjV6qj16MZDC4MwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/goodsCheckTitle.png
// module id = 6sBC
// module chunks = 2